import React from "react";
import "../../container.css";
import { useHistory } from "react-router-dom";
import { replaceString } from "../../../utils/helpers/dataHelper";

export default function MemberDirectoryCard({ member, textEllipse }) {
  const history = useHistory();

  const memberDetails = () => {
    history.push({
      state: { id: member.id },
      pathname: "member-profile",
    });
  };

  return (
    <div
      className="rounded card_shadow cursor-pointer md:border"
      onClick={() => memberDetails()}
    >
      <img
        className={`object-fill w-full h-32 md:h-72`}
        src={member.profileImage}
        alt={"profile image"}
      />
      <div className="p-1 md:p-4">
        <div className="font-bold">{member.fullName}</div>
        <div className={`font-bold text-xs mb-2 ${textEllipse} w-48 md:w-full`}>
          {replaceString(member.officeType)}
        </div>
        <div>
          <span className="text-xs text-gray-400">
            {member?.boardOfTrusteeType}
          </span>
        </div>
      </div>
    </div>
  );
}
